function closeAllPopups() {
    document.querySelectorAll('.popup-custom-section--visible').forEach(function(popup) {
        closePopupSection(popup);
    });
}

function openPopupSection(popupSection) {
    if (!popupSection) return;

    // évite double ouverture
    if (popupSection.classList.contains('popup-custom-section--visible')) return;

    // important : reset propre AVANT init
    closeAllPopups();
    destroyPopupMedia(popupSection);

    
    popupSection.classList.remove('popup-custom-section--hidden');
    popupSection.classList.add('popup-custom-section--visible');
    popupSection.setAttribute('aria-hidden', 'false');
    
    initPopupMedia(popupSection);

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
}

function closePopupSection(popupSection) {
    if (!popupSection) return;

    destroyPopupMedia(popupSection);

    popupSection.classList.remove('popup-custom-section--visible');
    popupSection.classList.add('popup-custom-section--hidden');
    popupSection.setAttribute('aria-hidden', 'true');

    // check global
    var stillOpen = document.querySelector('.popup-custom-section--visible');

    if (!stillOpen) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    }
}

function initPopupMedia(popupSection) {
    // deferred-media
    var deferredMedias = popupSection.querySelectorAll('deferred-media');
    deferredMedias.forEach(function(media) {
        if (media.classList.contains('is-loaded')) return;

        var template = media.querySelector('template');
        if (!template) return;

        media.innerHTML = template.innerHTML;
        media.classList.add('is-loaded');
    });

    // HTML5 video
    var videos = popupSection.querySelectorAll('video');
    videos.forEach(function(video) {
        // Réinitialise le src et le data-src si nécessaire
        if (video.dataset.src && !video.src) {
            video.src = video.dataset.src;
            video.dataset.src = video.dataset.src; // Garde le lien pour la prochaine ouverture
        }

        video.currentTime = 0;

        // Autoplay uniquement si visible
        if (popupSection.classList.contains('popup-custom-section--visible')) {
            var playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
        }
    });

    // iframe
    var iframes = popupSection.querySelectorAll('iframe');
    iframes.forEach(function(iframe) {
        var src = iframe.dataset.originalSrc || iframe.getAttribute('src');
        if (!src) return;

        iframe.dataset.originalSrc = src;

        if (popupSection.classList.contains('popup-custom-section--visible')) {
            // Nettoie l'URL existante (supprime ?autoplay=1 si présent)
            src = src.replace(/[&?]autoplay=1/, '');

            // Ajoute ?autoplay=1
            src += (src.includes('?') ? '&' : '?') + 'autoplay=1';

            // Recharge l'iframe avec le nouveau src
            iframe.src = src;
            }
        else {
            iframe.src = 'about:blank';
        }

    });
}

function destroyPopupMedia(popupSection) {
    if (!popupSection) return;

    // HTML5 video
    var videos = popupSection.querySelectorAll('video');
    videos.forEach(function(video) {
        try {
            video.pause();
            video.currentTime = 0;
            video.removeAttribute('src');
            video.load(); // Réinitialise le buffer
            video.removeAttribute('data-src'); // Supprime le lien de la vidéo
        } catch (e) {
            console.error("Erreur lors de la réinitialisation de la vidéo:", e);
        }
    });

    // IFRAME (YouTube, Vimeo…)
    var iframes = popupSection.querySelectorAll('iframe');
    iframes.forEach(function(iframe) {
        // Sauvegarde l'original src avant de tout réinitialiser
        var originalSrc = iframe.dataset.originalSrc || iframe.getAttribute('src');
        // Réinitialise complètement l'iframe
        iframe.src = 'about:blank';
        iframe.removeAttribute('src');
        // Réinjecte l'original src pour la prochaine ouverture
        if (originalSrc) {
            iframe.dataset.originalSrc = originalSrc;
        }
    });

    // deferred-media (Shopify safe)
    var deferredMedias = popupSection.querySelectorAll('deferred-media');
    deferredMedias.forEach(function(media) {
        // Supprime le contenu injecté
        var template = media.querySelector('template');
        if (template) {
            media.innerHTML = '';
            media.appendChild(template);
            media.classList.remove('is-loaded');
        }
    });
}

function openPopupFromHash() {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return;

    var popup = document.querySelector('[data-popup-hash="' + hash + '"]');
    if (!popup) return;

    if (!popup.classList.contains('popup-custom-section--visible')) {
        openPopupSection(popup);
    }
}

window.addEventListener('load', function() {
    openPopupFromHash();

    if (window.location.hash) {
        window.scrollTo(0, 0);
    }
});

window.addEventListener('hashchange', function() {
    openPopupFromHash();
});

document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href').replace('#', '');
    if (!hash) return;

    var popup = document.querySelector('[data-popup-hash="' + hash + '"]');
    if (!popup) return;

    e.preventDefault();

    // update URL sans scroll
    history.pushState(null, '', '#' + hash);

    openPopupSection(popup);
});

document.addEventListener('click', function(event) {
    if (event.target.matches('.popup-custom-section__backdrop')) {
        var popup = event.target.closest('[data-popup-custom-section]');
        closePopupSection(popup);
    }
});

document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-open-popup-section-id]');
    if (!trigger) return;

    var sectionId = trigger.getAttribute('data-open-popup-section-id');
    if (!sectionId) return;

    var popupSection = document.querySelector(`section[id*="${sectionId}"]`);
    if (!popupSection) return;

    openPopupSection(popupSection);
});

document.addEventListener('click', function(event) {
    var closeButton = event.target.closest('[data-popup-custom-close]');
    if (!closeButton) return;

    var popupSection = closeButton.closest('[data-popup-custom-section]');
    if (!popupSection) return;

    closePopupSection(popupSection);
});

document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-close-popup-section-id]');
    if (!trigger) return;

    var sectionId = trigger.getAttribute('data-close-popup-section-id');
    if (!sectionId) return;

    var popupSection = document.querySelector(`section[id*="${sectionId}"]`);
    if (!popupSection) return;

    closePopupSection(popupSection);
});